import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Legal from "./pages/Legal";
import LegalDocument from "./pages/LegalDocument";

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = hash.slice(1);
    const jump = () =>
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    const raf = requestAnimationFrame(jump);
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/legal" element={<Legal />} />
        <Route
          path="/privacy-policy"
          element={<LegalDocument documentKey="privacy-policy" />}
        />
        <Route
          path="/terms-of-use"
          element={<LegalDocument documentKey="terms-of-use" />}
        />
        <Route
          path="/acceptable-use-policy"
          element={<LegalDocument documentKey="acceptable-use-policy" />}
        />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}
